import { render, staticRenderFns } from "./TestPlayer.vue?vue&type=template&id=ce89c4fe&"
import script from "./TestPlayer.vue?vue&type=script&lang=js&"
export * from "./TestPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports